"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var use_async_func_with_state_hook_1 = __importDefault(require("../../hooks/use-async-func-with-state.hook"));

var Backup_1 = __importDefault(require("@material-ui/icons/Backup"));

var async_progress_modal_component_1 = __importDefault(require("../../common-components/async-progress-modal/async-progress-modal.component"));

var CONFG_PROPS = {
  ProgressIcon: Backup_1.default,
  successText: 'シナリオの下書き保存に成功しました！',
  progressText: 'シナリオを下書き保存中',
  description: 'シナリオを下書き保存しますか？',
  cancelText: 'キャンセル',
  confirmText: '下書き保存'
};

var selectErrorMessage = function selectErrorMessage(error) {
  //TODO error handlling
  return error ? '下書き保存に失敗しました。' : '';
};

var SaveScenarioModal = function SaveScenarioModal(_ref) {
  var handleSaveScenario = _ref.handleSaveScenario,
      isOpen = _ref.isOpen,
      handleClose = _ref.handleClose;

  var _use_async_func_with_ = use_async_func_with_state_hook_1.default(handleSaveScenario),
      _use_async_func_with_2 = _use_async_func_with_.state,
      isDone = _use_async_func_with_2.isDone,
      isPending = _use_async_func_with_2.isPending,
      error = _use_async_func_with_2.error,
      proceed = _use_async_func_with_.proceed,
      reset = _use_async_func_with_.reset;

  var closeAndReset = function closeAndReset() {
    handleClose();
    reset();
  };

  return react_1.default.createElement(async_progress_modal_component_1.default, Object.assign({
    isDone: isDone,
    isPending: isPending,
    errorMessage: selectErrorMessage(error),
    onConfirmClick: proceed,
    isOpen: isOpen,
    handleClose: closeAndReset,
    handleSuccess: closeAndReset
  }, CONFG_PROPS));
};

exports.default = SaveScenarioModal;